module.exports = __webpack_public_path__ + "static/media/membership.dde44648.svg";